import type { ReactNode } from 'react';
import { AlertTriangle, CheckCircle2, Info, OctagonAlert } from 'lucide-react';

type Tone = 'info' | 'warning' | 'danger' | 'success';

interface CalloutProps {
  tone?: Tone;
  title?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

const ICONS: Record<Tone, typeof Info> = {
  info: Info,
  warning: AlertTriangle,
  danger: OctagonAlert,
  success: CheckCircle2,
};

/**
 * One per page. `danger` is for failures, not for "below threshold" — that is
 * `warning`. Body is a sentence; actions are text or secondary buttons.
 */
export function Callout({ tone = 'info', title, children, actions, className }: CalloutProps) {
  const Icon = ICONS[tone];
  return (
    <div className={['ui-callout', `ui-callout--${tone}`, className].filter(Boolean).join(' ')} role="status">
      <Icon />
      <div className="ui-callout-body">
        {title && <div className="ui-callout-title">{title}</div>}
        {children}
      </div>
      {actions && <div className="ui-callout-actions">{actions}</div>}
    </div>
  );
}
